(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annual-sale"] && !Shopify.designMode) return;
  try {
    
// 在主题编辑器选择商品 block 时，移动端轮播定位到该商品。
document.addEventListener('shopify:block:select', event => {
  const block = event.target.closest('[data-sale-block]') || event.target.querySelector('[data-sale-block]');
  if (!block) return;
  const slider = block.closest('custom-swiper-section.annual-sale__products');
  if (!slider?.swiper || slider.swiper.destroyed) return;
  const cards = [...slider.querySelectorAll('[data-sale-block]')];
  const index = cards.indexOf(block);
  if (index >= 0) slider.swiper.slideTo(index, 0);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["double11-cursor"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('double11-cursor')) return;
  class Double11Cursor extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.particles = [];
      this.frame = 0;
      this.lastPaint = 0;
      this.lastEmission = -Infinity;
      this.lastMove = -Infinity;
      this.mouse = null;
      this.halo = null;
      this.count = 0;
      this.media = matchMedia('(hover: hover) and (pointer: fine)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.canvas = document.createElement('canvas');
      this.canvas.className = 'double11-cursor-canvas';
      this.canvas.setAttribute('aria-hidden', 'true');
      this.canvas.style.zIndex = this.dataset.layer || '40';
      document.body.appendChild(this.canvas);
      this.ctx = this.canvas.getContext('2d');
      if (!this.ctx) { this.canvas.remove(); return; }
      const signal = this.abort.signal;
      this.media.addEventListener('change', () => this.sync(), { signal });
      this.reduced.addEventListener('change', () => this.sync(), { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      document.addEventListener('pointermove', event => this.move(event), { passive: true, signal });

      document.addEventListener('pointerout', event => {
        if (!event.relatedTarget) { this.mouse = null; this.lastMove = -Infinity; }
      }, { passive: true, signal });
      window.addEventListener('blur', () => {
        this.mouse = null;
        this.lastMove = -Infinity;
      }, { signal });
      window.addEventListener('resize', () => this.resize(), { passive: true, signal });
      window.addEventListener('scroll', () => {
        this.mouse = null;
        this.lastMove = -Infinity;
        this.particles.length = 0;
        this.clear();
      }, { passive: true, signal });
      window.addEventListener('pagehide', () => this.stop(), { signal });
      window.addEventListener('pageshow', () => this.sync(), { signal });
      this.resize();
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.stop();
      this.canvas?.remove();
      this.particles = [];
    }
    sync() {
      this.enabled = this.dataset.enabled === 'true' && this.media.matches &&
        !this.reduced.matches && !document.hidden;
      this.canvas.hidden = !this.enabled;
      if (!this.enabled) {
        this.stop();
        this.particles.length = 0;
        this.mouse = null;
        this.halo = null;
        this.lastMove = -Infinity;
      }
    }
    resize() {
      this.width = innerWidth;
      this.height = innerHeight;
      const dpr = Math.min(devicePixelRatio || 1, 1.5);
      this.canvas.width = Math.round(this.width * dpr);
      this.canvas.height = Math.round(this.height * dpr);
      this.canvas.style.width = this.width + 'px';
      this.canvas.style.height = this.height + 'px';
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      this.particles.length = 0;
      this.mouse = null;
      this.lastMove = -Infinity;
    }
    move(event) {
      if (!this.enabled || event.pointerType !== 'mouse') return;
      const now = performance.now();
      const old = this.mouse;
      this.mouse = { x: event.clientX, y: event.clientY };
      if (!this.halo || !old) this.halo = { ...this.mouse };
      this.lastMove = now;
      const distance = old ? Math.hypot(event.clientX - old.x, event.clientY - old.y) : 20;
      // 时间和位移双重限制，避免高频鼠标事件堆积粒子。
      if (distance >= 2 && now - this.lastEmission >= 55) {
        const density = Math.max(1, Math.min(4, Number(this.dataset.density) || 2));
        for (let i = 0; i < density; i++) this.spawn(event.clientX, event.clientY);
        this.lastEmission = now;
      }
      this.start();
    }
    spawn(x, y) {
      if (this.particles.length >= 80) this.particles.shift();
      const serial = this.count++;
      const type = 'star';
      this.particles.push({
        x: x + (Math.random() - .5) * 12,
        y: y + (Math.random() - .5) * 12,
        vx: (Math.random() - .5) * 55,
        vy: -25 - Math.random() * 50,
        age: 0,
        life: (Number(this.dataset.lifetime) || 1100) * (.75 + Math.random() * .5),
        rotation: (Math.random() - .5) * .5,
        spin: (Math.random() - .5) * 1.5,
        size: 3 + Math.random() * 5,
        color: serial % 2 ? this.dataset.gold || '#FFD579' : this.dataset.red || '#CD2124',
        type
      });
    }
    start() {
      if (!this.frame) {
        this.lastPaint = 0;
        this.frame = requestAnimationFrame(time => this.draw(time));
      }
    }
    clear() { this.ctx?.clearRect(0, 0, this.width || 0, this.height || 0); }
    stop() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastPaint = 0;
      this.clear();
    }
    draw(now) {
      this.frame = 0;
      if (!this.enabled || !this.isConnected) return;
      // 最多约 30fps；页面恢复时也不会累计大步长。
      if (this.lastPaint && now - this.lastPaint < 30) {
        this.frame = requestAnimationFrame(time => this.draw(time));
        return;
      }
      const dt = Math.min(50, this.lastPaint ? now - this.lastPaint : 33) / 1000;
      this.lastPaint = now;
      const ctx = this.ctx;
      this.clear();
      this.particles = this.particles.filter(p => {
        p.age += dt * 1000;
        if (p.age >= p.life) return false;
        const progress = p.age / p.life;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.vy += 48 * dt;
        p.rotation += p.spin * dt;
        ctx.save();
        ctx.globalAlpha = Math.min(1, p.age / 90) * Math.pow(1 - progress, 1.25);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        const size = p.size * (1 - progress * .35);
        ctx.fillStyle = p.color;
          ctx.beginPath();
          for (let i = 0; i < 8; i++) {
            const a = i * Math.PI / 4;
            const radius = i % 2 ? size * .28 : size;
            if (i === 0) ctx.moveTo(Math.cos(a) * radius, Math.sin(a) * radius);
            else ctx.lineTo(Math.cos(a) * radius, Math.sin(a) * radius);
          }
          ctx.closePath();
          ctx.fill();
        ctx.restore();
        return true;
      });
      if (this.particles.length) this.frame = requestAnimationFrame(time => this.draw(time));
    }
  }
  customElements.define('double11-cursor', Double11Cursor);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-timeline"] && !Shopify.designMode) return;
  try {
    
(() => {
    if (customElements.get('gift-timeline-section')) return;
    class GiftTimelineSection extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const start = () => {
          this.initFrame = requestAnimationFrame(() => {
            if (this.isConnected) this.init();
          });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.events.signal });
        } else start();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        clearTimeout(this.timer);
        cancelAnimationFrame(this.initFrame);
        this.observer?.disconnect();
        this.trackResize?.disconnect();
        clearTimeout(this.trackSettle);
        clearTimeout(this.trackTargetTimer);
        cancelAnimationFrame(this.trackFrame);
        clearTimeout(this.navSettle);
        cancelAnimationFrame(this.navFrame);
        this.navManual = false;
        this.navPressed = false;
        this.ready = false;
      }
      getActivityState(now, start, end) {
        if (now < start) return 'upcoming';
        if (now < end) return 'active';
        return 'ended';
      }
      currentIndex(now) {
        let candidate = -1;
        this.stages.forEach((stage, i) => {
          if (now >= stage.start && now < stage.end && (candidate < 0 || stage.start >= this.stages[candidate].start))
            candidate = i;
        });
        if (candidate >= 0) return candidate;
        const next = this.stages
          .map((stage, i) => ({ ...stage, i }))
          .filter((stage) => now < stage.start)
          .sort((a, b) => a.start - b.start)[0];
        if (next) return next.i;
        return this.stages.reduce((best, stage, i) => (stage.end > this.stages[best].end ? i : best), 0);
      }
      init() {
        if (this.ready) return;
        this.nav = this.querySelector('.gift-timeline__nav');
        this.tabs = [...this.querySelectorAll('.gift-timeline__tab')];
        this.panels = [...this.querySelectorAll('.gift-timeline__panel')];
        if (!this.nav || this.tabs.length !== 3 || this.panels.length !== 3) return;
        this.ready = true;
        this.selected = -1;
        this.signature = '';
        this.mobile = matchMedia('(max-width: 767px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.stages = this.tabs.map((tab) => ({
          start: Date.parse(tab.dataset.start),
          end: Date.parse(tab.dataset.end),
          timezone:
            /T.*(?:Z|[+-]\d{2}:\d{2})$/i.test(tab.dataset.start) && /T.*(?:Z|[+-]\d{2}:\d{2})$/i.test(tab.dataset.end),
        }));
        if (
          this.stages.some(
            (s) => !Number.isFinite(s.start) || !Number.isFinite(s.end) || s.end <= s.start || !s.timezone
          )
        ) {
          this.dataset.invalid = 'true';
          console.error('[gift-timeline] 请检查开始/结束时间，必须包含时区，例如 2026-10-22T00:00:00+08:00');
          return;
        }
        delete this.dataset.invalid;
        const signal = this.events.signal;
        this.initTrack(signal);
        this.initNavSync(signal);
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, { animate: true, scroll: true }), { signal });
          tab.addEventListener(
            'keydown',
            (event) => {
              if (!this.mobile.matches) return;
              let next = i;
              if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
              else if (event.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
              else if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = this.tabs.length - 1;
              else return;
              event.preventDefault();
              this.select(next, { animate: true, scroll: true });
              this.tabs[next].focus({ preventScroll: true });
            },
            { signal }
          );
        });
        this.mobile.addEventListener('change', () => {
          clearTimeout(this.trackSettle);
          clearTimeout(this.trackTargetTimer);
          this.trackTarget = null;
          this.select(this.selected, { scroll: true });
          this.setupReveal();
        }, { signal });
        this.reduced.addEventListener('change', () => this.setupReveal(), { signal });
        document.addEventListener('visibilitychange', () => this.updateTime(), { signal });
        window.addEventListener(
          'pagehide',
          () => {
            clearTimeout(this.timer);
            this.observer?.disconnect();
          },
          { signal }
        );
        window.addEventListener(
          'pageshow',
          (event) => {
            if (event.persisted) {
              this.updateTime();
              this.select(this.selected, { scroll: true });
              this.setupReveal();
            }
          },
          { signal }
        );
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const block =
              event.target.closest('[data-editor-stage]') || event.target.querySelector('[data-editor-stage]');
            if (block && this.contains(block)) {
              this.select(Number(block.dataset.editorStage), { scroll: true });
            }
          },
          { signal }
        );
        this.updateTime();
        this.setupReveal();
      }
      initNavSync(signal) {
        this.bindSingleSwipe(this.nav, signal);
        this.bindSingleSwipe(this.track, signal);
      }
      bindSingleSwipe(element, signal) {
        let gesture = null;
        let suppressUntil = 0;
        let wheelLocked = false;
        let wheelDelta = 0;
        let wheelTimer;
        const step = (start, direction) => {
          const index = Math.max(0, Math.min(this.tabs.length - 1, start + direction));
          this.select(index, { animate: true, scroll: true });
        };
        element.addEventListener('pointerdown', event => {
          if (!this.mobile.matches || (event.pointerType === 'mouse' && event.button !== 0)) return;
          if (event.target.closest('input,textarea,select,[contenteditable]')) return;
          gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, index: this.selected, axis: null, switched: false };
          // 停住上一次程序滚动，以当前已选阶段作为本次手势起点。
          clearTimeout(this.trackSettle);
        }, { passive: true, signal });
        window.addEventListener('pointermove', event => {
          if (!gesture || event.pointerId !== gesture.id || !this.mobile.matches) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 10) {
            if (Math.abs(dx) > Math.abs(dy) * 1.1) gesture.axis = 'x';
            else if (Math.abs(dy) > Math.abs(dx) * 1.1) gesture.axis = 'y';
          }
          if (gesture.axis !== 'x') return;
          suppressUntil = performance.now() + 500;
          if (gesture.switched || Math.abs(dx) < 24) return;
          gesture.switched = true;
          step(gesture.index, dx < 0 ? 1 : -1);
        }, { passive: true, signal });
        element.addEventListener('dragstart', event => {
          if (this.mobile.matches) event.preventDefault();
        }, { signal });
        window.addEventListener('pointerup', event => {
          if (!gesture || event.pointerId !== gesture.id) return;
          const start = gesture;
          gesture = null;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (start.switched) {
            suppressUntil = performance.now() + 500;
            return;
          }
          if (!this.mobile.matches || start.axis === 'y' || Math.abs(dx) < 18 || Math.abs(dx) <= Math.abs(dy)) return;
          suppressUntil = performance.now() + 350;
          step(start.index, dx < 0 ? 1 : -1);
        }, { passive: true, signal });
        window.addEventListener('pointercancel', event => {
          if (gesture && event.pointerId === gesture.id) gesture = null;
        }, { passive: true, signal });
        element.addEventListener('click', event => {
          if (performance.now() < suppressUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        element.addEventListener('wheel', event => {
          if (!this.mobile.matches || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          // 横向触控板的一段连续滚动也只触发一次。
          if (event.cancelable) event.preventDefault();
          clearTimeout(wheelTimer);
          wheelTimer = setTimeout(() => { wheelLocked = false; wheelDelta = 0; }, 220);
          if (wheelLocked) return;
          wheelDelta += event.deltaX;
          if (Math.abs(wheelDelta) < 20) return;
          wheelLocked = true;
          step(this.selected, wheelDelta > 0 ? 1 : -1);
        }, { passive: false, signal });
        signal.addEventListener('abort', () => clearTimeout(wheelTimer), { once: true });
      }

      initTrack(signal) {
        this.track = this.querySelector('.gift-timeline__panels');
        if (!this.track) {
          this.track = document.createElement('div');
          this.track.className = 'gift-timeline__panels';
          this.panels[0].before(this.track);
          this.panels.forEach(panel => this.track.appendChild(panel));
        }
        this.track.addEventListener('scroll', () => {
          if (!this.mobile.matches || !this.track.clientWidth) return;
          clearTimeout(this.trackSettle);
          this.trackSettle = setTimeout(() => this.finishTrackScroll(), 140);
        }, { passive: true, signal });
        this.track.addEventListener('pointerdown', () => {
          this.trackTarget = null;
          clearTimeout(this.trackTargetTimer);
        }, { passive: true, signal });
        if ('ResizeObserver' in window) {
          this.trackResize = new ResizeObserver(() => this.updateTrackHeight());
          this.panels.forEach(panel => this.trackResize.observe(panel));
        }
        window.addEventListener('resize', () => {
          cancelAnimationFrame(this.trackFrame);
          this.trackFrame = requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.updateTrackHeight();
            if (this.mobile.matches && this.selected >= 0) this.moveTrack(this.selected, false);
          });
        }, { passive: true, signal });
      }
      updateTrackHeight() {
        if (!this.track) return;
        if (!this.mobile.matches) {
          this.track.style.removeProperty('height');
          return;
        }
        const panel = this.panels[this.selected];
        if (!panel) return;
        const height = Math.ceil(panel.getBoundingClientRect().height);
        if (height > 0 && this.track.style.height !== height + 'px') {
          this.track.style.height = height + 'px';
        }
      }
      moveTrack(index, animate) {
        if (!this.track || !this.mobile.matches) return;
        this.trackTarget = index;
        clearTimeout(this.trackTargetTimer);
        this.track.scrollTo({
          left: index * this.track.clientWidth,
          behavior: animate && !this.reduced.matches ? 'smooth' : 'auto'
        });
        this.trackTargetTimer = setTimeout(() => {
          this.trackTarget = null;
          this.finishTrackScroll();
        }, 700);
      }
      finishTrackScroll() {
        if (!this.mobile.matches || !this.track?.clientWidth) return;
        const index = Math.max(0, Math.min(this.panels.length - 1,
          Math.round(this.track.scrollLeft / this.track.clientWidth)));
        if (this.trackTarget != null && index !== this.trackTarget) return;
        this.trackTarget = null;
        clearTimeout(this.trackTargetTimer);
        if (index !== this.selected) this.select(index, { scroll: true, fromTrack: true });
        else this.updateTrackHeight();
      }

      updateAccessibility() {
        if (this.mobile.matches) this.nav.setAttribute('role', 'tablist');
        else this.nav.removeAttribute('role');
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('role', this.mobile.matches ? 'tab' : 'button');
          if (this.mobile.matches) tab.setAttribute('aria-selected', String(i === this.selected && tab.dataset.state !== 'upcoming'));
          else tab.removeAttribute('aria-selected');
          tab.tabIndex = this.mobile.matches && i !== this.selected ? -1 : 0;
          this.panels[i].setAttribute('role', this.mobile.matches ? 'tabpanel' : 'region');
          this.panels[i].tabIndex = this.mobile.matches && i !== this.selected ? -1 : 0;
          this.panels[i].inert = this.mobile.matches && i !== this.selected;
          if (this.mobile.matches) this.panels[i].setAttribute('aria-hidden', String(i !== this.selected));
          else this.panels[i].removeAttribute('aria-hidden');
        });
      }
      select(index, { animate = false, scroll = false, fromTrack = false } = {}) {
        if (!Number.isInteger(index) || !this.tabs[index]) return;
        this.selected = index;
        this.tabs.forEach((tab, i) => {
          tab.classList.toggle('is-selected', i === index && tab.dataset.state !== 'upcoming');
          this.panels[i].classList.toggle('is-selected', i === index);
          this.panels[i].classList.remove('is-switching');
        });
        this.updateAccessibility();
        this.updateTrackHeight();
        if (this.mobile.matches && !fromTrack) this.moveTrack(index, animate);
        if (this.mobile.matches && scroll) {
          this.navManual = false;
          clearTimeout(this.navSettle);
          cancelAnimationFrame(this.navFrame);
          const tabRect = this.tabs[index].getBoundingClientRect();
          const navRect = this.nav.getBoundingClientRect();
          const x = this.nav.scrollLeft + tabRect.left - navRect.left - (this.nav.clientWidth - tabRect.width) / 2;
          this.nav.scrollTo({ left: Math.max(0, x), behavior: animate && !this.reduced.matches ? 'smooth' : 'auto' });
        }
      }
      updateTime() {
        const now = Date.now();
        const labels = { upcoming: '未開始', active: '進行中', ended: '已結束' };
        const states = this.stages.map((s) => this.getActivityState(now, s.start, s.end));
        this.tabs.forEach((tab, i) => {
          if (tab.dataset.state !== states[i]) {
            tab.dataset.state = states[i];
            tab.querySelector('.gift-timeline__status').textContent = labels[states[i]];
          }
        });
        const signature = states.join('|');
        if (signature !== this.signature || this.selected < 0) {
          this.select(this.currentIndex(now), { scroll: true });
          this.signature = signature;
        }
        clearTimeout(this.timer);
        if (!document.hidden) {
          const next = this.stages
            .flatMap((s) => [s.start, s.end])
            .filter((t) => t > now)
            .sort((a, b) => a - b)[0];
          this.timer = setTimeout(() => this.updateTime(), Math.max(20, next ? Math.min(30000, next - now) : 30000));
        }
      }
      setupReveal() {
        this.observer?.disconnect();
        if (this.dataset.revealEnabled !== 'true' || this.reduced.matches || !('IntersectionObserver' in window)) {
          this.classList.remove('has-reveal');
          return;
        }
        this.classList.add('has-reveal');
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.08, rootMargin: '0px 0px -24px 0px' }
        );
        if (!this.mobile.matches && this.track) {
          this.track.removeAttribute('data-reveal');
        }
        const revealTargets = this.mobile.matches && this.track ? [this.track] : this.panels;
        [this.querySelector('.gift-timeline__heading'), ...revealTargets].forEach((el) => {
          el.setAttribute('data-reveal', '');
          if (!el.classList.contains('is-visible')) this.observer.observe(el);
        });
      }
    }
    customElements.define('gift-timeline-section', GiftTimelineSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reward-promos"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('reward-promo-wheel')) return;
  class RewardPromoWheel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.inView = !('IntersectionObserver' in window);
      this.sync = () => {
        this.classList.toggle('is-playing', this.inView && !document.hidden);
      };
      document.addEventListener('visibilitychange', this.sync, { signal: this.controller.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        });
        this.observer.observe(this);
      }
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.classList.remove('is-playing');
    }
  }
  customElements.define('reward-promo-wheel', RewardPromoWheel);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-fireworks"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('slideshow-fireworks-controller')) return;
  const hosts = new WeakMap();
  const positions = [
    [45, 56, 90], [98, 18, 160], [80, 30, 165],
    [35, 54, 185], [67, 62, 140], [15, 81, 100],
    [84, 85, 110], [8, 48, 120], [92, 53, 130],
    [47, 82, 145], [65, 14, 105], [30, 12, 115]
  ];

  class SlideshowFireworksController extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.frame = 0;
      this.mountFrame = 0;
      this.elapsed = 0;
      this.started = null;
      this.inView = false;
      this.rays = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 767px)');
      const signal = this.abort.signal;
      this.motion.addEventListener('change', () => this.sync(), { signal });
      this.mobile.addEventListener('change', () => this.sync(), { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      document.addEventListener('DOMContentLoaded', () => this.scheduleMount(), { signal, once: true });
      window.addEventListener('pagehide', () => this.pause(), { signal });
      window.addEventListener('pageshow', () => this.sync(), { signal });
      document.addEventListener('shopify:section:load', () => this.scheduleMount(), { signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) {
          this.host?.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      }, { signal });
      this.mutations = new MutationObserver(() => this.scheduleMount());
      this.mutations.observe(document.documentElement, { childList: true, subtree: true });
      this.scheduleMount();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.mutations?.disconnect();
      cancelAnimationFrame(this.mountFrame);
      this.unmount();
    }

    scheduleMount() {
      if (this.mountFrame) return;
      this.mountFrame = requestAnimationFrame(() => {
        this.mountFrame = 0;
        if (this.isConnected) this.mount();
      });
    }

    mount() {
      if (this.dataset.enabled !== 'true') {
        this.unmount();
        return;
      }
      let target;
      try {
        target = document.querySelector(this.dataset.target || 'slide-show');
      } catch (error) {
        if (!this.warned) console.warn('[slideshow-fireworks] 目标选择器格式错误', error);
        this.warned = true;
        this.unmount();
        return;
      }
      if (target === this.host && this.stage?.parentElement === target) return;
      this.unmount();
      if (!target) return;
      this.host = target;

      // 仅为原本 static 的容器补定位；最后一个烟花层移除时恢复。
      let record = hosts.get(target);
      if (!record) {
        record = {
          count: 0,
          changed: getComputedStyle(target).position === 'static',
          value: target.style.getPropertyValue('position'),
          priority: target.style.getPropertyPriority('position')
        };
        hosts.set(target, record);
        if (record.changed) target.style.setProperty('position', 'relative');
      }
      record.count++;

      this.stage = document.createElement('div');
      this.stage.className = 'slideshow-fireworks-layer';
      this.stage.setAttribute('aria-hidden', 'true');
      this.stage.style.setProperty('--sf-color', this.dataset.color);
      this.stage.style.setProperty('--sf-size-scale', Number(this.dataset.size) / 100);
      this.stage.style.setProperty('--sf-mobile-scale', Number(this.dataset.mobileSize) / 100);
      this.stage.style.zIndex = this.dataset.layer;
      target.appendChild(this.stage);
      this.duration = Math.max(1600, Number(this.dataset.duration) || 2800);
      const count = Math.min(positions.length, Math.max(1, Number(this.dataset.count) || 7));
      const template = this.querySelector('template');
      if (!template) { this.unmount(); return; }
      this.rays = [];
      positions.slice(0, count).forEach(([x, y, size], index) => {
        const firework = template.content.firstElementChild.cloneNode(true);
        firework.style.setProperty('--sf-x', x + '%');
        firework.style.setProperty('--sf-y', y + '%');
        firework.style.setProperty('--sf-size', size + 'px');
        this.stage.appendChild(firework);
        firework.querySelectorAll('path').forEach((path, i) => {
          // 起点靠近烟花中心，用来确定线条的扩散方向；不依赖容器可见时的 getBBox。
          const point = path.getAttribute('d').match(/^M\s*([-\d.]+)[ ,]+([-\d.]+)/i);
          const dx = point ? Number(point[1]) - 25 : 1;
          const dy = point ? Number(point[2]) - 22 : 0;
          const length = Math.hypot(dx, dy) || 1;
          this.rays.push({
            path, x: dx / length, y: dy / length,
            delay: (i % 4) * 12, offset: index * this.duration / count
          });
        });
      });
      this.inView = false;
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.intersection.observe(target);
      } else this.inView = true;
      this.sync();
    }

    sync() {
      if (!this.stage) return;
      const deviceAllowed = this.mobile.matches
        ? this.dataset.mobile === 'true'
        : this.dataset.desktop === 'true';
      const allowed = deviceAllowed && !this.motion.matches;
      this.stage.hidden = !allowed;
      if (allowed && this.inView && !document.hidden) {
        if (!this.frame) {
          this.started = null;
          this.frame = requestAnimationFrame(time => this.draw(time));
        }
      } else this.pause();
    }

    draw(time) {
      this.frame = 0;
      if (!this.stage || !this.isConnected) return;
      if (this.started === null) this.started = time - this.elapsed;
      this.elapsed = time - this.started;
      const clamp = value => Math.max(0, Math.min(1, value));
      this.rays.forEach(({ path, x, y, delay, offset }) => {
        const age = this.elapsed - offset;
        if (age < 0) { path.style.opacity = '0'; return; }
        const t = Math.max(0, age % this.duration - delay);
        const bloom = 1 - Math.pow(1 - clamp(t / 560), 3);
        const fade = clamp((t - 720) / 620);
        const scale = (0.05 + bloom * 0.95) * (1 - fade * 0.16);
        const tx = 25 * (1 - scale) + x * fade * 6;
        const ty = 22 * (1 - scale) + y * fade * 6 + fade * fade * 2;
        path.setAttribute('transform', 'translate(' + tx + ' ' + ty + ') scale(' + scale + ')');
        path.style.opacity = String(clamp(t / 90) * (1 - fade));
      });
      this.frame = requestAnimationFrame(next => this.draw(next));
    }

    pause() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.started = null;
    }

    unmount() {
      this.pause();
      this.intersection?.disconnect();
      this.stage?.remove();
      if (this.host) {
        const record = hosts.get(this.host);
        if (record && --record.count === 0) {
          if (record.changed) {
            if (record.value) this.host.style.setProperty('position', record.value, record.priority);
            else this.host.style.removeProperty('position');
          }
          hosts.delete(this.host);
        }
      }
      this.host = null;
      this.stage = null;
      this.rays = [];
      this.elapsed = 0;
    }
  }
  customElements.define('slideshow-fireworks-controller', SlideshowFireworksController);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('promo-inset-video')) return;
  class PromoInsetVideo extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.media = matchMedia('(max-width: 767px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.near = false;
      this.userPaused = false;
      const signal = this.events.signal;
      this.media.addEventListener('change', () => {
        this.release();
        this.userPaused = false;
        if (this.near) this.mountVideo();
        this.sync();
      }, { signal });
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.video?.pause();
        else this.sync();
      }, { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      window.addEventListener('pagehide', () => this.video?.pause(), { signal });
      window.addEventListener('pageshow', () => this.sync(), { signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('.video-offer__play');
        const isVideo = event.target === this.video && !this.video?.controls;
        if (!button && !isVideo) return;
        this.mountVideo();
        if (!this.video) return;
        if (this.video.paused) {
          this.userPaused = false;
          this.video.play().catch(() => this.classList.remove('is-playing'));
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.loadObserver = new IntersectionObserver(entries => {
          this.near = entries[0].isIntersecting;
          if (this.near) { this.mountVideo(); this.sync(); }
        }, { rootMargin: '300px 0px' });
        this.viewObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) { this.near = true; this.mountVideo(); }
          this.sync();
        }, { threshold: .1 });
        this.loadObserver.observe(this);
        this.viewObserver.observe(this);
      } else {
        this.near = this.inView = true;
        this.mountVideo();
        this.sync();
      }
    }
    mountVideo() {
      if (this.video) return;
      const device = this.media.matches ? 'mobile' : 'desktop';
      const template = this.querySelector('template[data-device="' + device + '"]');
      if (!template) return;
      this.video = template.content.querySelector('video').cloneNode(true);
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.preload = 'metadata';
      this.videoEvents = new AbortController();
      const signal = this.videoEvents.signal;
      this.video.addEventListener('playing', () => {
        this.classList.add('is-playing', 'has-played');
        this.updateButton();
      }, { signal });
      this.video.addEventListener('pause', () => {
        this.classList.remove('is-playing');
        this.updateButton();
      }, { signal });
      this.video.addEventListener('ended', () => {
        this.classList.remove('is-playing');
        this.updateButton();
      }, { signal });
      this.video.addEventListener('error', () => {
        this.classList.remove('is-playing', 'has-played');
        this.updateButton();
      }, { signal });
      this.appendChild(this.video);
    }
    updateButton() {
      const button = this.querySelector('.video-offer__play');
      if (button) {
        button.setAttribute('aria-label', this.video && !this.video.paused ? '暫停影片' : '播放影片');
        button.setAttribute('aria-pressed', String(!!this.video && !this.video.paused));
        button.querySelector('path')?.setAttribute('d', this.video && !this.video.paused ? 'M14 12h4v16h-4zM22 12h4v16h-4z' : 'M16 12l13 8-13 8z');
      }
    }
    sync() {
      if (!this.video) return;
      if (document.hidden || !this.inView) this.video.pause();
      else if (this.dataset.autoplay === 'true' && !this.reduced.matches && !this.userPaused) {
        this.video.play().catch(() => this.classList.remove('is-playing'));
      }
    }
    release() {
      this.videoEvents?.abort();
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
        this.video.remove();
        this.video = null;
      }
      this.classList.remove('is-playing', 'has-played');
      this.updateButton();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.loadObserver?.disconnect();
      this.viewObserver?.disconnect();
      this.release();
    }
  }
  customElements.define('promo-inset-video', PromoInsetVideo);
})();


  } catch(e) { console.error(e); }
})();
})();
